// extracted by mini-css-extract-plugin
export default {"wrapper":"product-lockup-module__wrapper--Evh","logo":"product-lockup-module__logo--OlI"};